import { FileDownload } from '@mui/icons-material';
import LoadingButton from '@mui/lab/LoadingButton';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import { useInvoiceQuery } from '../../../api/gql';
import { currencies, getPriceWithCurrencyString } from '../../../utils/currencies';
import { formatDate } from '../../../utils/format';
import { fromCentesimal } from '../../../utils/transform';
import { InvoicePDFDocument } from './InvoicePdfDocument';

type Props = {
  invoiceId: string;
};
export const InvoiceDownloadButton = ({ invoiceId }: Props) => {
  const { t } = useTranslation();
  const { data, isLoading } = useInvoiceQuery(
    {
      id: invoiceId ?? '',
    },
    {
      select: (res) => ({
        ...res.invoice,
        amount: getPriceWithCurrencyString(fromCentesimal(res.invoice.amount ?? 0), res.invoice.currency),
        currency: currencies.find((curr) => curr.value === res.invoice.currency?.toLowerCase())?.label ?? '-',
        issueDate: formatDate(new Date(res.invoice.issueDate)),
        dueDate: formatDate(new Date(res.invoice.dueDate)),
        items: res.invoice.items.map((item) => ({
          ...item,
          priceSum: getPriceWithCurrencyString(fromCentesimal(item.priceSum), res.invoice.currency),
          pricePerUnit: getPriceWithCurrencyString(fromCentesimal(item.pricePerUnit), res.invoice.currency),
        })),
      }),
    },
  );

  if (!data) {
    return null;
  }

  return (
    <PDFDownloadLink document={<InvoicePDFDocument data={data} />} fileName={`upominej-faktura-${data.number}.pdf`}>
      {({ loading }) => (
        <LoadingButton startIcon={<FileDownload />} variant={'outlined'} loading={loading || isLoading}>
          {t('invoice.download')}
        </LoadingButton>
      )}
    </PDFDownloadLink>
  );
};
